/* global angular*/

(function (angular) {
    'use strict';

    var fileBrowser = angular.module('GorillaBoy.FileBrowser');

    fileBrowser.factory('StringHashSet', function () {
        function StringHashSet () {
            this.backingStore = {};
        }

        StringHashSet.prototype.clear = function setClear () {
            this.backingStore = {};
        };


        StringHashSet.prototype.add = function setAdd (str) {
            if (angular.isUndefined(this.backingStore[str])) {
                this.backingStore[str] = true;
            }
        };


        StringHashSet.prototype.get = function getItem (str) {
            return this.backingStore[str];
        };

        StringHashSet.prototype.deleteItem = function setDelete (str) {
            delete this.backingStore[str];
        };

        StringHashSet.prototype.size = function setSize () {
            var size = 0, key;

            for (key in this.backingStore) {
                if (this.backingStore.hasOwnProperty(key)) {
                    size += 1;
                }
            }

            return size;
        };


        StringHashSet.prototype.has = function setContains (str) {
            return angular.isDefined(this.backingStore[str]);
        };


        /**
         * Returns an Array that contains every element in the Set.
         */
        StringHashSet.prototype.entries = function getSetEntries () {
            var values = [], key;

            for (key in this.backingStore) {
                if (this.backingStore.hasOwnProperty(key)) {
                    values.push(key);
                }
            }

            return values;
        };

        return StringHashSet;
    });
}(angular));
